import { useCallback, useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import styles from './SiteBeacon.module.css';

import { motifPaths } from '../data/motifs.js'


const beaconMotifPath = motifPaths.observer.path;


function SiteBeacon({darkBeacon}) {


    return (

        <div className={styles.siteBeacon + " " + (darkBeacon ? styles.darkBeacon : "")} >
            <a href="https://jlliew.com">
                <svg className={styles.beaconMotif + " " + (darkBeacon ? styles.darkBeacon : "")}>{beaconMotifPath}</svg>
            </a>
            <h1 className={styles.beaconTitle}>Jonathan Liew</h1>

        </div>

    );
}

export default SiteBeacon;
